export default {

    isAnimating: false

}


/** WEBPACK FOOTER **
 ** ./base/store.js
 **/